module.exports = __webpack_public_path__ + "img/ic-fundanow-cash-check.ad03da72.svg";